import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb, { getCategoryBreadcrumb } from '@/components/feature/Breadcrumb';
import CategoryTabs from '@/components/feature/CategoryTabs';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <div className="pt-24 pb-12 text-center">
          <h1 className="text-2xl font-bold text-foreground-900">分类未找到</h1>
          <Link to="/" className="text-primary-600 hover:text-primary-700 mt-4 inline-block cursor-pointer">
            返回首页
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const breadcrumbItems = getCategoryBreadcrumb(slug);
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 国产在线`,
    description: category.description,
    url: `https://guochanzx.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '国产在线',
      url: 'https://guochanzx.com',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-12">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />

            <div className="mt-6 mb-8">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-900" style={{ fontFamily: 'var(--font-heading)' }}>
                {category.name}
              </h1>
              <p className="text-sm text-foreground-500 mt-2 max-w-2xl leading-relaxed">
                {category.description}
              </p>
            </div>

            <div className="mb-8">
              <CategoryTabs activeSlug={slug} />
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无内容</p>
                <Link
                  to="/"
                  className="text-primary-600 hover:text-primary-700 mt-3 inline-block text-sm cursor-pointer"
                >
                  返回首页浏览更多内容
                </Link>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}